import { createBlock } from '@wordpress/blocks';

const transforms = {
	from: [
		{
			type: 'block',
			blocks: [ 'core/code', 'core/paragraph', 'core/verse' ],
			transform: ( { content, anchor } ) =>
				createBlock( 'core/preformatted', {
					content,
					anchor,
				} ),
		},
		{
			type: 'raw',
			isMatch: ( node ) =>
				node.nodeName === 'PRE' &&
				! (
					node.children.length === 1 &&
					node.firstChild.nodeName === 'CODE'
				),
			schema: ( { phrasingContentSchema } ) => ( {
				pre: {
					children: phrasingContentSchema,
				},
			} ),
		},
	],
	to: [
		{
			type: 'block',
			blocks: [ 'core/paragraph' ],
			transform: ( attributes ) =>
				createBlock( 'core/paragraph', attributes ),
		},
		{
			type: 'block',
			blocks: [ 'core/code' ],
			transform: ( attributes ) => createBlock( 'core/code', attributes ),
		},
		{
			type: 'block',
			blocks: [ 'core/verse' ],
			transform: ( attributes ) =>
				createBlock( 'core/verse', attributes ),
		},
	],
};

export default transforms;
